import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { PillColorType } from '@eg/ui';
import { trainStatusColors } from '../color-pills-consts';
import { DispoOrderTrainVisitModel, TrainVisitModel } from '@railmybox/api-dispo';

@Component({
  selector: 'rmb-train-card',
  templateUrl: './train-card.component.html',
  styleUrl: './train-card.component.scss',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TrainCardComponent implements OnInit, OnChanges {
  readonly TRANSLOCO_PREFIX = 'capacity-management';
  @Input() trainInfo: TrainVisitModel;
  @Output() toggleExpand: EventEmitter<string> = new EventEmitter<string>();
  @Input() expanded = false;
  @Input() isAdmin = true;
  trainStatusColors: PillColorType = trainStatusColors;
  allRows: DispoOrderTrainVisitModel[][] = [];
  visibleRows: DispoOrderTrainVisitModel[][] = [];
  rowsToShow = 8;

  ngOnInit(): void {
    this.createRowsOfTwo();
    this.updateVisibleRows();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['trainInfo'] && !changes['trainInfo'].firstChange) {
      this.createRowsOfTwo();
      this.updateVisibleRows();
    }
  }

  onExpand(id?: string) {
    this.toggleExpand.emit(id);
  }

  onShowMore() {
    this.rowsToShow += 8;
    this.updateVisibleRows();
  }

  createRowsOfTwo() {
    this.allRows = [];
    const dispoOrders = this.trainInfo?.dispoOrders || [];

    for (let i = 0; i < dispoOrders.length; i += 2) {
      this.allRows.push(dispoOrders.slice(i, i + 2));
    }
  }

  get hasMoreRows() {
    return this.rowsToShow < this.allRows.length;
  }

  updateVisibleRows() {
    this.visibleRows = this.allRows.slice(0, this.rowsToShow);
  }
}
